/**
 * Navbar burger
 * 
 * @link https://bulma.io/documentation/components/navbar/#navbar-menu
 *
 */
document.addEventListener('DOMContentLoaded', () => {
    let burgers = document.querySelectorAll('.navbar-burger');

    burgers.forEach((burger) => {
        burger.addEventListener('click', () => {
            const data = burger.dataset.target;
            const target = document.getElementById(data);

            let active = !burger.classList.contains('is-active');

            burger.classList.toggle('is-active');
            burger.setAttribute('aria-expanded', active);
            target.classList.toggle('is-active');
        });
    });

    /* visible submenu on focused submenu links */
    let sublinks = document.querySelectorAll('.menu-primary .sub-menu a');

    sublinks.forEach((sublink, i) => {
        let parentlink = sublink.closest('.menu-item-has-children').querySelector('a'); /* get first child link */

        sublink.addEventListener('focus', (e) => {
            parentlink.classList.add('is-focused');
        });

        sublink.addEventListener('blur', (e) => {
            parentlink.classList.remove('is-focused');
        });
    });
});



/**
 * Navbar on Scroll (made with Claude)
 *
 */
const navbar = document.querySelector('nav.navbar.is-fixed-top');
const body = document.body;
const html = document.documentElement;

let navbarHeight = navbar ? navbar.offsetHeight : 0;

// Scroll-Handler mit Throttling für bessere Performance
let ticking = false;

function updateScrollState() {
  const scrollTop = html.scrollTop || body.scrollTop;
  
  if (scrollTop > navbarHeight) {
    body.classList.add('is-scrolled');
  } else {
    body.classList.remove('is-scrolled');
  }
  
  ticking = false;
}

// Event Listener mit passivem Flag für bessere Performance
window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(updateScrollState);
    ticking = true;
  }
}, { passive: true });

// Initial ausführen
updateScrollState();
